import { render, staticRenderFns } from "./settings-gradient.vue?vue&type=template&id=d9e9042e&"
import script from "./settings-gradient.vue?vue&type=script&lang=js&"
export * from "./settings-gradient.vue?vue&type=script&lang=js&"
import style0 from "./settings-gradient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports